export default __webpack_public_path__ + "images/icon-definitions.v0.0.62.svg";